var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2093 16.821L15.2093 16.8211L27.9881 25.7062C26.3996 27.715 24.3404 29.3025 21.9917 30.3276C19.5948 31.3738 16.9733 31.8006 14.3683 31.5688C11.7633 31.337 9.25842 30.4541 7.08385 29.0012C4.90929 27.5482 3.13487 25.572 1.92374 23.254C0.712599 20.9361 0.103609 18.3509 0.152755 15.736C0.201901 13.1212 0.907606 10.5607 2.20499 8.28991C3.50237 6.01912 5.3498 4.11091 7.57742 2.74073C9.76019 1.39814 12.2394 0.614337 14.7956 0.457505V16.0288C14.7956 16.0288 14.7956 16.0288 14.7956 16.0288C14.7955 16.1845 14.8331 16.3378 14.9051 16.4757C14.9772 16.6137 15.0815 16.7321 15.2093 16.821ZM17.456 16.0335L29.1236 7.98746C30.5923 10.4224 31.3666 13.2142 31.3609 16.0598C31.3552 18.9055 30.5697 21.6941 29.0913 24.1232L17.456 16.0335ZM16.7248 14.1947V0.457639C18.9207 0.594241 21.0634 1.19418 23.0118 2.21869C24.9603 3.24322 26.6692 4.66853 28.0264 6.40026L16.7248 14.1947Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSector);
export default __webpack_public_path__ + "static/media/sector.9d0f0799495f346eb3d0e66b1d3cf237.svg";
export { ForwardRef as ReactComponent };